"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function AmazondynamodbGreenMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__amazondynamodb-green-multitone-filled__clip0_13467_102)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M10.025 16h.19l3.113-1.588.051-.075V1.662l-.051-.075L10.216 0h-.193l.002 16zM5.975 16h-.193l-3.11-1.588-.063-.11-.032-12.576.095-.14L5.782 0h.195l-.002 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M5.787 0h4.426v16H5.787V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M14.957 7.64l-.105-.023-1.502-.143-.022.01-3.115-.126H5.787l-3.114.127V5.06l-.003.002.003-.007 3.114-.737h4.426l3.115.737 1.145.62v-.398l.483-.054-.05-.1-1.532-1.118-.046.015-3.115-.985H5.787l-3.114.985V1.587l-1.63 1.947v1.7l.013-.009.471.053v.408l-.484.264v1.692l.013-.001.471.007v.71l-.406.006-.078-.007v1.692l.484.266v.412l-.463.052-.02-.015v1.7l1.628 1.948v-2.435l3.115.986h4.426l3.123-.988.042.019 1.512-1.102.066-.11-.484-.054v-.404l-.063-.026-1.035.57-.038.08-3.123.731v.001H5.787l-3.115-.736V8.51l3.115.127v.003h4.426l3.114-.13.07.034 1.456-.128.103-.052-.484-.007v-.71l.485-.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M13.328 11.977v2.435l1.628-1.948v-1.689l-1.62 1.2-.008.002zM13.328 10.949l.009-.002 1.62-.89v-1.7l-1.63.154v2.438zM13.337 5.058l-.01-.002v2.43l1.63.155v-1.7l-1.62-.883zM13.337 4.031l1.62 1.193V3.535l-1.63-1.948v2.435l.01.004v.006zM9.243 0h.811v16h-.81V0zM5.844 0h.81v16h-.81V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.84 9.54V6.86a1.18 1.18 0 00-.102-.51.738.738 0 00-.311-.334 1.072 1.072 0 00-.532-.118c-.19 0-.356.032-.5.097a.736.736 0 00-.322.274.708.708 0 00-.113.397H5.537c0-.24.057-.467.172-.682.115-.218.277-.412.489-.58.215-.172.47-.306.768-.403a3.29 3.29 0 011.01-.145c.44 0 .832.075 1.176.226.347.147.62.369.816.666.2.297.301.671.301 1.122v2.536c0 .29.018.538.054.746.04.204.096.381.172.532v.091H9.05a2.141 2.141 0 01-.156-.558 4.381 4.381 0 01-.054-.677zm.2-2.304l.01.843h-.897c-.222 0-.417.023-.586.07a1.082 1.082 0 00-.413.193.784.784 0 00-.242.3.914.914 0 00-.08.393c0 .143.032.272.096.387a.739.739 0 00.29.274c.13.064.28.096.451.096.251 0 .47-.05.656-.15a1.29 1.29 0 00.435-.376.812.812 0 00.166-.42l.408.613c-.05.147-.125.303-.225.468-.1.164-.23.318-.387.461a1.968 1.968 0 01-.57.355c-.221.093-.479.14-.773.14-.376 0-.712-.076-1.01-.226a1.79 1.79 0 01-.703-.618 1.586 1.586 0 01-.258-.891c0-.308.057-.58.172-.817.115-.236.285-.435.51-.596.226-.165.505-.288.838-.37a4.685 4.685 0 011.155-.13h.956z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__amazondynamodb-green-multitone-filled__clip0_13467_102"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H13.913V16H0z",
    transform: "translate(1.043)"
  }))));
}

AmazondynamodbGreenMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
AmazondynamodbGreenMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = AmazondynamodbGreenMultitoneFilled;
exports["default"] = _default;